import React, { useEffect, useState } from 'react';
import { ReportFilter } from "../../Model/Inscription/InscriptionReportFilter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";

// Interfaz para cada filtro
interface Filter {
    field: string;
    operator: string;
    value: string;
    type: string;
}

// Props para el componente DynamicFilters
interface DynamicFiltersProps {
    items: Record<string, ReportFilter>; // Lista de items como un objeto clave-valor
    onFiltersChanged?: (filters: Filter[]) => void; // Callback opcional para manejar cambios en los filtros
}

const DynamicFilters: React.FC<DynamicFiltersProps> = ({ items, onFiltersChanged }) => {
    const [filters, setFilters] = useState<Filter[]>([]);
    const itemKeys = Object.keys(items);

    const handleFilterChange = (index: number, key: keyof Filter, value: string) => {
        const updatedFilters = [...filters];
        updatedFilters[index] = { ...updatedFilters[index], [key]: value };

        if (key === 'field') {
            // Asegúrate de que TypeScript sabe que los valores son del tipo `ReportFilter`
            const selectedItem = Object.values(items).find((item): item is ReportFilter => item.field === value);
            if (selectedItem) {
                updatedFilters[index].operator = selectedItem.operators[0];
                updatedFilters[index].type = selectedItem.type; // Actualiza el tipo del input
                updatedFilters[index].value = ''; // Actualiza el tipo del input
            }
        }

        setFilters(updatedFilters);
    };

    const addNewFilter = () => {
        const firstKey = itemKeys[0];
        const firstItem = items[firstKey];
        setFilters([
            ...filters,
            { field: firstItem.field, operator: firstItem.operators[0], value: '', type: firstItem.type },
        ]);
    };

    const removeFilter = (index: number) => {
        setFilters(filters.filter((_, i) => i !== index));
    };

    useEffect(() => {
        if (onFiltersChanged) {
            onFiltersChanged(filters);
        }
    }, [filters]);

    return (
        <div>
            {filters.map((filter, index) => {
                const fieldKey = itemKeys.find((key) => items[key].field === filter.field);
                const operators = fieldKey ? items[fieldKey].operators : [];

                return (
                    <div key={index} style={{ display: 'flex', marginBottom: '10px' }}>
                        <select
                            className={"form-select"}
                            value={filter.field}
                            onChange={(e) => handleFilterChange(index, 'field', e.target.value)}
                            style={{ marginRight: '10px' }}
                        >
                            {itemKeys.map((key) => (
                                <option key={key} value={items[key].field}>
                                    {items[key].label}
                                </option>
                            ))}
                        </select>
                        <select
                            className={"form-select"}
                            value={filter.operator}
                            onChange={(e) => handleFilterChange(index, 'operator', e.target.value)}
                            style={{ marginRight: '10px' }}
                        >
                            {operators.map((op) => (
                                <option key={op} value={op}>
                                    {op}
                                </option>
                            ))}
                        </select>
                        <input
                            className={"form-control"}
                            type={filter.type} // Cambia el tipo dinámicamente según el filtro
                            placeholder="Valor"
                            value={filter.value}
                            onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
                            style={{ marginRight: '10px' }}
                        />
                        <button
                            onClick={() => removeFilter(index)}
                            style={{ marginLeft: '5px' }}
                            className={"btn btn-danger btn-sm"}
                        >
                            <FontAwesomeIcon icon={faTrashCan} className={"pointer"} />
                        </button>
                    </div>
                );
            })}
            <button onClick={addNewFilter} className={"btn-sm btn btn-outline-dark"}>
                Añadir filtro
            </button>
        </div>
    );
};

export default DynamicFilters;